import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ChevronDownIcon, StarIcon, ShieldCheckIcon, TrendingUpIcon, ShoppingBagIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToNext = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex flex-col justify-center overflow-hidden pt-32 pb-20" data-id="element-109" data-mp="u8zsxsokip14">
      {/* Premium SaaS Background */}
      <div className="absolute inset-0 bg-[#020202]" data-id="element-110" data-mp="l9ux4u4e59sn">
        {/* Subtle grid */}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:4rem_4rem]" style={{
        maskImage: 'radial-gradient(ellipse 60% 50% at 50% 0%, #000 70%, transparent 100%)'
      }} data-id="element-111" data-mp="l7ryjlp6a8cb" />

        {/* Glows */}
        <div className="absolute top-[-10%] left-[20%] w-[40rem] h-[40rem] bg-[#D4AF37]/10 rounded-full blur-[120px] opacity-50 mix-blend-screen" data-id="element-112" data-mp="25pg2x6hcsdgl" />
        <div className="absolute top-[10%] right-[20%] w-[30rem] h-[30rem] bg-emerald-500/10 rounded-full blur-[120px] opacity-40 mix-blend-screen" data-id="element-113" data-mp="25ffeqfp9g85i" />

        {/* Noise texture */}
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-15 mix-blend-overlay pointer-events-none" data-id="element-114" data-mp="2k5wgk05t502x" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full flex flex-col items-center text-center" data-id="element-115" data-mp="1rfwl0rx74zcq">
        {/* Eyebrow Badge */}
        <div className="inline-flex flex-wrap items-center justify-center gap-3 px-4 py-2 rounded-full bg-white/[0.03] border border-white/10 backdrop-blur-md mb-10" data-id="element-116" data-mp="21dkgxl6jgcwh">
          <div className="flex items-center gap-1.5" data-id="element-117" data-mp="1wcwiwfjw6vsr">
            <ShieldCheckIcon className="w-4 h-4 text-emerald-400" data-id="element-118" data-mp="3cs7qi1fb0dce" />
            <span className="text-xs font-semibold text-emerald-300 tracking-wide uppercase" data-id="element-119" data-mp="3cuk98gsvyrqi">
              Shopify Partner
            </span>
          </div>
          <div className="w-1 h-1 rounded-full bg-white/20" data-id="element-120" data-mp="3ew1bxclvo64g" />
          <a href="https://www.fiverr.com/webpankaj" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 rounded-full text-[#F3E5AB] hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37] focus-visible:ring-offset-2 focus-visible:ring-offset-black" aria-label="Verify Pankaj Maurya's Fiverr Pro profile" data-id="element-121" data-mp="3jvnr3rl9nwfw">
            <StarIcon className="w-4 h-4 text-[#D4AF37] fill-[#D4AF37]" data-id="element-122" data-mp="315pmjlgoglh0" />
            <span className="text-xs font-semibold tracking-wide uppercase" data-id="element-123" data-mp="363r23wewa2nq">
              Fiverr Pro
            </span>
          </a>
        </div>

        {/* Headline */}
        <h1 className="text-6xl md:text-8xl lg:text-[7rem] font-bold tracking-tighter mb-8 leading-[1.05] text-white" data-id="element-124" data-mp="2dgde4nt6chfr">
          Elite Shopify
          <br data-id="element-125" data-mp="2id3sn6pbz4z2" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-gray-300 to-gray-500" data-id="element-126" data-mp="2icu31k876ztw">
            Development.
          </span>
        </h1>

        {/* Subheadline */}
        <p className="text-xl md:text-2xl text-gray-400 max-w-3xl mx-auto mb-12 leading-relaxed font-medium" data-id="element-127" data-mp="vg48g50wknrt">
          We build high-converting stores, premium themes, and powerful apps for
          ambitious ecommerce brands.{' '}
          <span className="text-gray-300" data-id="element-128" data-mp="glhl50za7hdk">
            Not just web designers, but Shopify specialists.
          </span>
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center gap-5 w-full sm:w-auto mb-24" data-id="element-129" data-mp="bsy948g8suav">
          <Link to="/contact" className="w-full sm:w-auto bg-white text-black px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 flex items-center justify-center gap-2 group hover:scale-105 shadow-[0_0_40px_rgba(255,255,255,0.1)]" data-id="element-130" data-mp="7sw5htqy5qsy">
            Start Your Project
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-131" data-mp="1sxmw6ujz48bu" />
          </Link>
          <Link to="/portfolio" className="w-full sm:w-auto px-8 py-4 rounded-full font-bold text-lg text-white border border-white/10 bg-white/[0.03] hover:bg-white/[0.08] backdrop-blur-md transition-all duration-300 flex items-center justify-center hover:scale-105" data-id="element-132" data-mp="1xx972xcbxchh">
            View Portfolio
          </Link>
        </div>

        {/* Authority / Stats Band */}
        <div className="w-full max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 pt-10 border-t border-white/10" data-id="element-133" data-mp="1f6rhv2qpgz0v">
          <div className="flex flex-col items-center justify-center p-4" data-id="element-134" data-mp="10a92d5bknsvy">
            <div className="flex items-center gap-2 mb-2" data-id="element-135" data-mp="1578yooimdh9v">
              <ShoppingBagIcon className="w-5 h-5 text-emerald-400" data-id="element-136" data-mp="159vgri34zf6c" />
              <span className="text-3xl md:text-4xl font-bold text-white tracking-tight" data-id="element-137" data-mp="2uni6ehlcmm6t">
                1,000+
              </span>
            </div>
            <span className="text-sm text-gray-500 font-medium uppercase tracking-wider" data-id="element-138" data-mp="nygg6hc7d335">
              Stores Built
            </span>
          </div>

          <div className="flex flex-col items-center justify-center p-4" data-id="element-139" data-mp="j17u45nxoewm">
            <div className="flex items-center gap-2 mb-2" data-id="element-140" data-mp="xpkudeu20jwx">
              <StarIcon className="w-5 h-5 text-[#D4AF37] fill-[#D4AF37]" data-id="element-141" data-mp="sxt4z7mmwk8d" />
              <span className="text-3xl md:text-4xl font-bold text-white tracking-tight" data-id="element-142" data-mp="svq23n0duwm8">
                700+
              </span>
            </div>
            <span className="text-sm text-gray-500 font-medium uppercase tracking-wider" data-id="element-143" data-mp="12odzaiv9z2lh">
              5-Star Reviews
            </span>
          </div>

          <div className="flex flex-col items-center justify-center p-4" data-id="element-144" data-mp="1glawr35wfibc">
            <div className="flex items-center gap-2 mb-2" data-id="element-145" data-mp="1bou0tmsgjznp">
              <TrendingUpIcon className="w-5 h-5 text-blue-400" data-id="element-146" data-mp="3ie8mur8ajwsl" />
              <span className="text-3xl md:text-4xl font-bold text-white tracking-tight" data-id="element-147" data-mp="3iglddss47fh9">
                100M+
              </span>
            </div>
            <span className="text-sm text-gray-500 font-medium uppercase tracking-wider" data-id="element-148" data-mp="1hdkiqg44tbsq">
              Client Revenue
            </span>
          </div>

          <div className="flex flex-col items-center justify-center p-4" data-id="element-149" data-mp="1mdgks9t9qt5n">
            <div className="flex items-center gap-2 mb-2" data-id="element-150" data-mp="1qbw3w2m8bhds">
              <ShieldCheckIcon className="w-5 h-5 text-purple-400" data-id="element-151" data-mp="1vck51h469elq" />
              <span className="text-3xl md:text-4xl font-bold text-white tracking-tight" data-id="element-152" data-mp="20beliceo2r2o">
                100%
              </span>
            </div>
            <span className="text-sm text-gray-500 font-medium uppercase tracking-wider" data-id="element-153" data-mp="2596oq2krhzm6">
              Shopify Focused
            </span>
          </div>
        </div>
      </div>

      <button onClick={scrollToNext} className="absolute bottom-8 left-1/2 -translate-x-1/2 text-gray-600 hover:text-white transition-colors animate-bounce" aria-label="Scroll down" data-id="element-154" data-mp="2e31lonbqcjqq">
        <ChevronDownIcon className="w-6 h-6" data-id="element-155" data-mp="2o1r3yh7jg67i" />
      </button>
    </section>;
}